module.exports = __webpack_public_path__ + "img/white.415695c8.webp";